import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import { Loader2 } from "lucide-react";

/**
 * NewPatientRedirect — Navigates immediately to the full registration form.
 * Patient + encounter records are now created on-demand when the user
 * clicks "Next Step" in Create.tsx, so no API calls are made here.
 */
export default function NewPatientRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/patients/new/new/create", { replace: true });
  }, [navigate]);

  return (
    <MainLayout>
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-gray-600">
          <Loader2 className="w-10 h-10 animate-spin text-[#1a7a4a]" />
          <p className="text-lg font-medium">Starting Registration...</p>
        </div>
      </div>
    </MainLayout>
  );
}
